import { createMiddleware } from 'reacticoon/middleware'
import { redirectTo } from 'reacticoon/routing'
import { saveSession, removeMfaLoggingUserId } from 'modules/auth/config'
import { postLoginMfa } from './actions'

export const onLoginSucceedMiddleware = createMiddleware(
  'App::LoginMfaModule::onLoginMfaSucceedMiddleware',
  postLoginMfa.SUCCESS,
  ({ action, dispatch }) => {
    removeMfaLoggingUserId()
    saveSession(action.response.token)
    dispatch(redirectTo('DASHBOARD'))
  }
)